export const USER_ROLE = {
  ADMIN: "Admin",
  USER: "Personal",
  AGENT: "Angency",
};
